import { useState, useEffect } from "react";
import axiosInstance from "./axiosInstance";

const useEntity = ({ endpoint, selectedItem, onSuccess }) => {

    const [item, setItem] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const isNew = selectedItem === true;

    useEffect(() => {
        if (!selectedItem) return;

        const fetchData = async () => {
            try {
                setIsLoading(true);

                const res = await axiosInstance.get(
                    `${endpoint}/${selectedItem}`
                );

                setItem(res.data);

            } catch (err) {
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [endpoint, selectedItem]);

    const save = async () => {
        try {
            setSaving(true);

            if (isNew) {
                await axiosInstance.post(
                    `${endpoint}/${selectedItem}`,
                    item
                );
            } else {
                await axiosInstance.put(
                    `${endpoint}/${selectedItem}`,
                    item
                );
            }

            onSuccess?.();

        } catch (err) {
            console.error(err);
        } finally {
            setSaving(false);
        }
    };

    return {
        item,
        setItem,
        isLoading,
        saving,
        save
    };
};

export default useEntity;